// Module
var code = " <button ng-click=\"$ctrl.validateForm()\" class=\"btn btn-primary\" ng-disabled=\"$ctrl.isProcessing\"> <span ng-show=\"$ctrl.icon\" ng-class=\"$ctrl.icon\"></span><span ng-transclude></span> </button>";
// Exports
module.exports = code;